import React__default from 'react';
import classNames from 'classnames';
import './../../vendor/tslib/tslib.es6.js';
import '../Icon/Icon.module.css.js';
import { CloseIcon } from '../Icon/icons/CloseIcon.js';
import { createIsSupportedVariant } from '../utils.js';
import styles from './InlineAlert.module.css.js';
import { isSupportedCtaComponent } from './utils.js';

var VARIANT_NAMES = ['info', 'success', 'warning', 'danger', 'opportunity'];
var getIsSupportedVariant = createIsSupportedVariant(VARIANT_NAMES);
var CloseButton = function (_a) {
    var onClick = _a.onClick, closeTitle = _a.closeTitle;
    return (React__default.createElement("button", { className: styles.closeButton, type: "button", onClick: onClick, title: closeTitle === null || closeTitle === void 0 ? void 0 : closeTitle.toString() },
        React__default.createElement(CloseIcon, null)));
};
var InlineAlert = function (_a) {
    var _b;
    var _c = _a.variant, variant = _c === void 0 ? 'info' : _c, title = _a.title, description = _a.description, icon = _a.icon, closeOnClick = _a.closeOnClick, closeTitle = _a.closeTitle, cta = _a.cta, className = _a.className;
    var safeVariant = getIsSupportedVariant(variant) ? variant : 'info';
    var rootClassName = classNames(styles.root, styles[safeVariant], className);
    var bodyClassName = classNames(styles.body, (_b = {},
        _b[styles.bodyHasCloseButton] = !!closeOnClick,
        _b));
    return (React__default.createElement("div", { className: rootClassName, "data-testid": "InlineAlert" },
        icon && (React__default.createElement("div", { className: styles.iconCol },
            React__default.createElement("div", { className: styles.icon, "data-testid": "InlineAlert__icon" }, icon))),
        React__default.createElement("div", { className: styles.mainCol },
            React__default.createElement("div", { className: bodyClassName },
                title && React__default.createElement("div", { className: styles.title }, title),
                description && React__default.createElement("div", { className: styles.description }, description)),
            cta && isSupportedCtaComponent(cta) && (React__default.createElement("div", { className: styles.cta, "data-testid": "InlineAlert__cta" }, cta)),
            closeOnClick && (React__default.createElement("div", { className: styles.close },
                React__default.createElement(CloseButton, { onClick: closeOnClick, closeTitle: closeTitle }))))));
};

export { InlineAlert };
//# sourceMappingURL=InlineAlert.js.map
